module.exports = __webpack_public_path__ + "img/Iconset_DGBRT--29.1cb45bf5.png";